import {Fancybox} from '@fancyapps/ui';
import "@fancyapps/ui/dist/fancybox.css"

VIV.behaviours.imageSlider = (function () {

    const attach = function (context) {
        const blocks = context.querySelectorAll('.imageSlider');

        if (blocks.length === 0) {
            return;
        }

        // Async load swiper library and init slideshow when loaded
        import(/* webpackChunkName: "slider" */ "swiper").then(module => {
            blocks.forEach(block => init(block, context, module));
        });

        Fancybox.bind("[data-fancybox]", {
            infinite: false,
            preload: 0,
        });
    };

    const init = function (block, context, module) {
        const Swiper = module.default;

        const navigationSliderElement = block.querySelector(`.imageSlider__navigationSlider`);
        let navigationSlider;
        if (navigationSliderElement) {
            navigationSlider = new Swiper(navigationSliderElement, {
                modules: [module.Navigation, module.EffectFade],
                wrapperClass: 'imageSlider__navigationSliderItems',
                slideClass: 'imageSlider__navigationSliderItem',
                freeMode: true,
                speed: 300,
                spaceBetween: 20,
                slidesPerView: 3,
                navigation: {
                    nextEl: document.querySelector('.imageSlider__navigationSliderNavigationItem--next'),
                    prevEl: document.querySelector('.imageSlider__navigationSliderNavigationItem--previous'),
                    disabledClass: `imageSlider__navigationSliderNavigationItem--disabled`,
                    hiddenClass: `imageSlider__navigationSliderNavigationItem--hidden`,
                    lockClass: `imageSlider__navigationSliderNavigationItem--lock`,
                }
            });
        }

        const bigSliderElement = block.querySelector(`.imageSlider__bigSlider`);
        const bigSlider = new Swiper(bigSliderElement, {
            modules: [module.Navigation, module.EffectFade, module.Thumbs],
            effect: 'fade',
            wrapperClass: 'imageSlider__bigSliderItems',
            slideClass: 'imageSlider__bigSliderItem',
            slidesPerView: 1,
            speed: 300,
            thumbs: navigationSliderElement ? {swiper: navigationSlider} : null
        });
    };

    return {
        attach: attach
    }
})();
